<script>
import { mapState } from "pinia";
import { useAppStore } from "@/app-store/app";

export default {
  name: "menuButton",
  computed: {
    ...mapState(useAppStore, ["layoutConfig"]),
    buttonClasses() {
      let classes = "";
      if (this.layoutConfig && this.layoutConfig.navbar) {
        if (this.layoutConfig.navbar.menuTextSize) {
          classes += ` text-${this.layoutConfig.navbar.menuTextSize}`;
        }
        if (this.layoutConfig.navbar.menuTextColor) {
          classes += ` text-color-${this.layoutConfig.navbar.menuTextColor}`;
        }
        if (this.layoutConfig.navbar.menuFont) {
          classes += ` font-${this.layoutConfig.navbar.menuFont}`;
        }
        if (this.layoutConfig.navbar.menuBackground) {
          classes += ` bg-color-${this.layoutConfig.navbar.menuBackground}`;
        }
        if (this.layoutConfig.navbar.menuBorder) {
          classes += ` border-2 border-color-${this.layoutConfig.navbar.menuBorder}`;
        }
        if (this.layoutConfig.navbar.menuShape) {
          let shapeClass = "rounded-none";
          switch (this.layoutConfig.navbar.menuShape) {
            case "rounded":
              shapeClass = "rounded-xl";
              break;
            case "full-rounded":
              shapeClass = "rounded-full";
              break;
          }
          classes += ` ${shapeClass}`;
        }
      }
      return classes;
    },
  },
};
</script>

<template>
  <router-link
    to="/menu"
    :class="`px-3 py-1 hover:opacity-75 transition-all ${buttonClasses}`"
  >
    MENU
  </router-link>
</template>

<style scoped></style>
